export default __webpack_public_path__ + "static/media/login-page-background-img.861faaeb.png";